import { Pagination } from 'swiper/modules';
import { Swiper } from 'swiper';

export class ProductBlockImages {
	private readonly element: HTMLElement;
	private sliderElement: HTMLElement;
	private navigationElement: HTMLElement;
	private navigationItemElements: Array<HTMLElement>;
	private slider: Swiper;
	private sliderSettings = {
		modules: [Pagination],
		slidesPerView: 1,
		pagination: {
			el: '.product-block-images__pagination',
			bulletClass: 'product-block-images__bullet',
			bulletActiveClass: 'product-block-images__bullet--active',
		},
		on: {
			init() {
				const navigation = document.createElement('div');
				navigation.classList.add('product-block-images__navigation');
				this.slides.forEach(() => navigation.insertAdjacentHTML('beforeend', '<div class="product-block-images__navigation-item"></div>'));
				this.el.append(navigation);
			},
		}
	};
 
	constructor(element: HTMLElement) {
		if (!element) return;
		this.element = element;
		this.init();
	}

	handleNavigationMouseOver = ({ target }): void => {
		const index = this.navigationItemElements.indexOf(target);
		this.slider.slideTo(index, 0);
	};

	handleNavigationMouseLeave = (): void => {
		this.slider.slideTo(0, 0);
	};

	public init = (): void => {
		this.slider = new Swiper(this.element, this.sliderSettings);
		this.navigationElement = this.element.querySelector('.product-block-images__navigation');
		this.navigationItemElements = [...this.navigationElement.childNodes];
		this.navigationElement.addEventListener('mouseover', this.handleNavigationMouseOver);
		this.navigationElement.addEventListener('mouseleave', this.handleNavigationMouseLeave);
		window.app.classInstance.set(this.element, this);
	};

	public destroy = (): void => {
		this.navigationElement.removeEventListener('mouseover', this.handleNavigationMouseOver);
		this.navigationElement.removeEventListener('mouseleave', this.handleNavigationMouseLeave);
		this.slider.destroy();
		this.slider = null;
		this.navigationElement = null;
		this.navigationItemElements = null;
		window.app.classInstance.del(this.element, this);
	};

	public reinit = (): void => {
		this.destroy();
		this.init();
	};
}
